import { render, staticRenderFns } from "./CurriculumWriteMenu.vue?vue&type=template&id=60d79d46&scoped=true&"
import script from "./CurriculumWriteMenu.vue?vue&type=script&lang=ts&"
export * from "./CurriculumWriteMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumWriteMenu.vue?vue&type=style&index=0&id=60d79d46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d79d46",
  null
  
)

export default component.exports